import { useProjectSidebarStore } from "@/zapi-frontend/stores/projectSidebarStore";
import { AppButton, Typography } from "@libs/zapi-ui/custom";
import { CardHeader } from "@libs/zapi-ui/shadcn";
import { XIcon } from "@phosphor-icons/react";
import { CheckCircle2Icon } from "lucide-react";
import { TClaimTab } from "../model/types";
import { cn } from "@/zapi-frontend/shared/lib/utils";

function ClaimCount({
  count,
  variant,
  isActive,
  onClick
}: {
  count: number;
  variant: TClaimTab;
  isActive: boolean;
  onClick: () => void;
}) {
  return (
    <div
      className={cn(
        "text-innoveraZinc-500 w-[40px] h-[24px] text-center rounded-md flex items-center justify-center gap-1 cursor-pointer",
        isActive && "bg-innoveraZinc-100"
      )}
      onClick={onClick}
    >
      {variant === "green" && <div className="w-1.5 h-1.5 rounded-full bg-innoveraGreen-700" />}
      {variant === "yellow" && <div className="w-1.5 h-1.5 rounded-full bg-yellow-400" />}
      {variant === "red" && <div className="w-1.5 h-1.5 rounded-full bg-[#A73528]" />}
      {variant === "reviewed" && <CheckCircle2Icon className="w-3 h-3 stroke-innoveraZinc-500" />}
      <Typography variant="label3" className="text-innoveraZinc-500">
        {count}
      </Typography>
    </div>
  );
}

export function ClaimsActiveHeader({
  counts,
  lastAnalyzedDate,
  selectedTab,
  onTabChange,
  reanalyzeSlot
}: {
  counts: Record<TClaimTab, number>;
  lastAnalyzedDate: string;
  selectedTab: TClaimTab;
  onTabChange: (tab: TClaimTab) => void;
  reanalyzeSlot: React.ReactNode;
}) {
  const { closeHandler } = useProjectSidebarStore();

  return (
    <CardHeader className="flex flex-col gap-4 border border-innoveraZinc-100 rounded-t-[8px] text-zinc-500 text-sm py-2 px-4">
      <div className="flex items-center justify-between">
        <Typography variant="label3" className="text-innoveraZinc-500">
          Last Analyzed: {lastAnalyzedDate}
        </Typography>

        <AppButton appearance="text" size="icon" onClick={closeHandler}>
          <XIcon />
        </AppButton>
      </div>
      <div className="flex items-center">
        {(["red", "yellow", "green", "reviewed"] as TClaimTab[]).map((tab) =>
          counts[tab] > 0 ? (
            <ClaimCount
              key={tab}
              count={counts[tab]}
              variant={tab}
              isActive={selectedTab === tab}
              onClick={() => onTabChange(tab)}
            />
          ) : null
        )}
        <div className="ml-auto">{reanalyzeSlot}</div>
      </div>
    </CardHeader>
  );
}
